<template>
  <v-checkbox
    v-bind="$attrs"
    v-model="value"
    color="szViolet"
    :false-value="null"
    :true-value="true"
    :error-messages="errorMessage"
    class="mt-0 pa-0 custom-checkbox-field"
  >
    <template #label>
      <div>
        <ExpandableText
          :class="{ 'prepend-required': required }"
          :text="label"
          :additional-text="detailsText"
        />
      </div>
    </template>
  </v-checkbox>
</template>

<script setup lang="ts">
import ExpandableText from '@/components/widgets/ExpandableText.vue';
import { useField } from 'vee-validate';
import { toRef } from 'vue';

type Props = {
    rules: string | Record<string, unknown>;
    required: boolean;
    name: string;
    label: string;
    detailsText?: string;
};

const props = defineProps<Props>();

const rulesRef = toRef(props, 'rules');

const { value, errorMessage } = useField(() => props.name, rulesRef, {
    syncVModel: true
});
</script>

<style lang="scss">
@use '@/assets/css/variables.scss' as variables;

.custom-checkbox-field {
  .v-input__details {
    min-height: 0;
  }
}
</style>
